export default "__VITE_ASSET__CZr$PGxP__"